import React, { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player/youtube";
import { useHistory } from "react-router-dom";
import cx from "classnames";
import styles from "../scss/DigitalAdvice.module.scss";
import Button from "../../common/components/Forms/Button/Button";
import Icon from "../../common/components/Icon/Icon";
import { AdviceControllerContext } from "../providers/DigitalAdviceProvider";
import DapCarousel from "../components/DapCarousel";
import useWindowDimensions from "../../common/hooks/useWindowDimensions";

const DigitalAdvice: React.FC = () => {
    const history = useHistory();
    const search = new URLSearchParams(location.search);
    const { actions } = useContext(AdviceControllerContext);
    const { isTabletPortrait } = useWindowDimensions();
    const [pageReady, setPageReady] = useState(false);
    const mode = search.has("mode") && search.get("mode");

    const getStarted = (params: string = ""): void => {
        actions.reset().finally(() => {
            if (mode === "app") window.localStorage.setItem("dap_mode", mode);
            history.push(`/digital-advice/59/question${params}`);
        });
    };

    useEffect(() => {
        window.localStorage.removeItem("dap_process");
        window.localStorage.removeItem("quote-modified-warning");
        window.localStorage.removeItem("dap_mode");
        if (mode === "app") getStarted(`?mode=${mode}`);
        if (!pageReady) setPageReady(true);
    }, [pageReady]);

    useEffect(() => {
        abTesting.convertAll(16, "", "", 0);
    }, []);

    return (
        <React.Fragment>
            {pageReady && (
                <div className={cx(styles["dap-mainpage"], styles["layout"], "gap-4xl")}>
                    <div
                        className={cx(
                            styles["dap-mainpage--div"],
                            "layout-flex-s",
                            "layout-flex-column--centered"
                        )}>
                        <h3 className={cx(styles["dap-title"], "gap-3xl")}>
                            Why should you care about insurance?
                        </h3>
                        <p className={cx(styles["dap-description"], "gap-3xl")}>
                            Bad things can happen, even to good people. It's life – we try
                            not to think about these things. Be brave – check out the
                            risks and within a few short minutes get quotes and arrange
                            cover to ensure that even if bad things happen, financially,
                            you will be okay, you can keep the house, and look after your
                            loved ones.
                        </p>
                        <p className={cx(styles["dap-description"], "gap-3xl")}>
                            We are all about you – and so we do life, disablement, and
                            health insurance. We are not looking at house, contents, or
                            car insurance in this advice process.
                        </p>
                        <div className={cx(styles["dap-packages"])}>
                            <DapCarousel
                                showArrows={false}
                                centerMode={isTabletPortrait}
                                infinite={isTabletPortrait}
                                isMini={true}
                                itemClass={styles["box-space"]}>
                                <div
                                    className={cx(
                                        styles["package-item"],
                                        "layout-flex-s"
                                    )}>
                                    <h3 className={styles["title"]}>1 IN 10</h3>
                                    <p className={styles["sub-title"]}>couples aged 30</p>
                                    <span className={styles["description"]}>
                                        one person permanently disabled before age 65*
                                    </span>
                                </div>
                                <div
                                    className={cx(
                                        styles["package-item"],
                                        "layout-flex-s"
                                    )}>
                                    <h3 className={styles["title"]}>1 IN 4</h3>
                                    <p className={styles["sub-title"]}>
                                        You or your partner
                                    </p>
                                    <span className={styles["description"]}>
                                        'major trauma' like cancer or heart disease*
                                    </span>
                                </div>
                                <div
                                    className={cx(
                                        styles["package-item"],
                                        "layout-flex-s"
                                    )}>
                                    <h3 className={styles["title"]}>1 IN 6</h3>
                                    <p className={styles["sub-title"]}>one of a couple</p>
                                    <span className={styles["description"]}>
                                        aged 30 will die before retirement*
                                    </span>
                                </div>
                            </DapCarousel>
                        </div>
                        <span className={cx(styles["dap-ouradvice"], "gap-3xl")}>
                            * source: Quality Product Research
                        </span>
                        <Button
                            className={"gap-2xl"}
                            width="content"
                            component="button"
                            size="m"
                            onClick={() => {
                                getStarted();
                            }}
                            variant="calltoaction">
                            <span>GET STARTED</span>
                        </Button>
                        <span className={cx(styles["dap-ouradvice"], "gap-s")}>
                            This process is designed for NZ Citizens aged 18 to 65.
                        </span>
                        <span className={cx(styles["dap-ouradvice"], "gap-3xl")}>
                            Please read our{" "}
                            <a
                                href="/our-service/important-information.aspx"
                                target="_blank">
                                Disclosure Information.
                            </a>
                        </span>
                    </div>
                    <div
                        className={cx(
                            styles["dap-mainpage--div"],
                            styles["dap-video-div"],
                            "layout-flex-s",
                            "layout-flex-column--centered"
                        )}>
                        <ReactPlayer url="http://youtu.be/OL9mEuuqho4" width="100%" />
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default DigitalAdvice;
